import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetOutboundsParams, TypeGetOutboundsResponse } from '~/types/delivery-agency.types';

/**
 * [운송장 관리] 출고 단위 조회 API
 */
const fetchOutbounds = async (params: TypeGetOutboundsParams): Promise<TypeGetOutboundsResponse['data']> => {
  const { data } = await axiosInstance.get<TypeGetOutboundsResponse>(API_ENDPOINT.DELIVERY_AGENCY.GET_OUTBOUNDS, {
    params,
  });
  return data.data;
};

/**
 * [운송장 관리] 출고 단위 조회 Mutation Hook
 */
export const useGetOutboundsMutation = () => {
  return useMutation({
    mutationFn: fetchOutbounds,
  });
};
